import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  viewChild,
} from '@angular/core'
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms'
import { MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field'
import { MatIcon } from '@angular/material/icon'
import { MatIconButton } from '@angular/material/button'
import { MatInput } from '@angular/material/input'
import { MatTooltip } from '@angular/material/tooltip'
import { MatSelectModule } from '@angular/material/select'
import { MatOption } from '@angular/material/core'
import { MatDialog } from '@angular/material/dialog'
import {
  MatDatepicker,
  MatDatepickerInput,
  MatDatepickerToggle,
} from '@angular/material/datepicker'
import moment from 'moment'
import { SearchPurchaseScheduleServiceOrderModel } from '../../../core/models/purchase-reservation.model'
import { ServiceOrderStatusService } from '../../../core/services/service/service-order-status/service-order-status.service'
import { VehicleTypeService } from '../../../core/services/vehicle/vehicle-type/vehicle-type.service'
import { DriverTypeService } from '../../../core/services/driver/driver-type/driver-type.service'
import { PurchaseServiceOrderService } from '../../../core/services/purchase-reservation/purchase-service-order/purchase-service-order.service'
import { ModalEmployeeConsultantOperationalComponent } from '../../../features/employee/modal-employee-consultant-operational/modal-employee-consultant-operational.component'
import { ModalLegalEntityClientComponent } from '../../../features/customer/modal_client/modal-legal-entity-client/modal-legal-entity-client.component'

@Component({
  selector: 'form-search-purchase-reservation-service-order',
  imports: [
    MatFormField,
    MatIcon,
    MatIconButton,
    MatInput,
    MatLabel,
    ReactiveFormsModule,
    MatTooltip,
    MatDatepicker,
    MatDatepickerInput,
    MatDatepickerToggle,
    MatSuffix,
    MatSelectModule,
    MatOption,
  ],
  templateUrl: './form-search-purchase-reservation-service-order.component.html',
  styleUrl: './form-search-purchase-reservation-service-order.component.scss',
})
export class FormSearchPurchaseReservationServiceOrderComponent implements OnInit, OnChanges {
  constructor(
    private formBuilder: FormBuilder,
    private serviceOrderStatusService: ServiceOrderStatusService,
    private vehicleTypeService: VehicleTypeService,
    private driverTypeService: DriverTypeService,
    private purchaseServiceOrderService: PurchaseServiceOrderService,
    private dialog: MatDialog,
  ) {}

  datepickerStart = viewChild<MatDatepicker<any>>('dateStart')
  datepickerEnd = viewChild<MatDatepicker<any>>('dateEnd')

  formSearch: FormGroup = new FormGroup({})
  @Output() responseSearch = new EventEmitter()
  @Input() search = ''

  statusOsList: any[] = []
  vehicleTypes: any[] = []
  driverTypes: any[] = []
  consultoresAtribuicao: any[] = []
  employeeConsultantSelected: any = {}
  clientSelected: any = {}

  ngOnInit() {
    this.createForm()
    this.getStatusOsList()
    this.getVehicleTypeList()
    this.getDriverTypeList()
    this.getConsultoresAtribuicao()
  }

  getConsultoresAtribuicao() {
    this.purchaseServiceOrderService.listConsultoresAtribuicao().subscribe({
      next: (response: any) => {
        this.consultoresAtribuicao = response.data ?? []
      },
      error: () => {
        this.consultoresAtribuicao = []
      },
    })
  }

  getStatusOsList() {
    this.serviceOrderStatusService.listServiceOrderStatus().subscribe({
      next: (response: any) => {
        this.statusOsList = response.data ?? []
      },
      error: () => {
        this.statusOsList = []
      },
    })
  }

  getVehicleTypeList() {
    this.vehicleTypeService.listVehicleType().subscribe({
      next: (response: any) => {
        this.vehicleTypes = response.data ?? []
      },
      error: () => {
        this.vehicleTypes = []
      },
    })
  }

  getDriverTypeList() {
    this.driverTypeService.listDriverType().subscribe({
      next: (response: any) => {
        this.driverTypes = response.data ?? []
      },
      error: () => {
        this.driverTypes = []
      },
    })
  }

  ngOnChanges() {}

  createForm(): void {
    this.formSearch = this.formBuilder.group({
      tgCode: [''],
      osCode: [''],
      client: [''],
      origin: [''],
      destination: [''],
      service: [''],
      vehicleType: [''],
      driverType: [''],
      dateStart: [''],
      dateEnd: [''],
      statusOsId: [''],
      consultant: [''],
      fornecedorAtribuidoPor: [''],
    })
  }

  addConsultanOperational() {
    const dialogRef = this.dialog.open(
      ModalEmployeeConsultantOperationalComponent,
      {
        enterAnimationDuration: '100ms',
        exitAnimationDuration: '100ms',
        maxWidth: '1200px',
        minWidth: '1200px',
        maxHeight: '650px',
        data: {
          item: this.employeeConsultantSelected,
          multiSelect: false,
        },
      },
    )
    dialogRef.componentInstance.responseSingle.subscribe((response: any) => {
      if (response) {
        if (response.remove == false) {
          this.employeeConsultantSelected = response.selection
          this.formSearch
            .get('consultant')!
            .setValue(this.employeeConsultantSelected.nome)
        } else {
          this.clearConsultant()
        }
      }
    })
  }

  clearConsultant() {
    this.employeeConsultantSelected = {}
    this.formSearch.get('consultant')!.setValue('')
  }

  addClient() {
    const dialogRef = this.dialog.open(ModalLegalEntityClientComponent, {
      enterAnimationDuration: '100ms',
      exitAnimationDuration: '100ms',
      maxWidth: '1200px',
      minWidth: '1200px',
      maxHeight: '650px',
      data: {
        item: this.clientSelected,
        multiSelect: false,
      },
    })
    dialogRef.componentInstance.responseSingle.subscribe((response: any) => {
      if (response) {
        if (response.remove == false) {
          this.clientSelected = response.selection
          this.formSearch.get('client')!.setValue(this.clientSelected.nomeFantasia)
        } else {
          this.clearClient()
        }
      }
    })
  }

  clearClient() {
    this.clientSelected = {}
    this.formSearch.get('client')!.setValue('')
  }

  sendSearch(search = true) {
    if (search && this.checkSearch()) {
      const searchModel = new SearchPurchaseScheduleServiceOrderModel()
      searchModel.codigoTg = this.toNullable(this.formSearch.get('tgCode')!.value)
      searchModel.codigoOs = this.toNullable(this.formSearch.get('osCode')!.value)
      searchModel.clienteId = this.toNullableNumber(this.clientSelected?.id)
      searchModel.descricaoOrigem = this.toNullable(
        this.formSearch.get('origin')!.value,
      )
      searchModel.descricaoDestino = this.toNullable(
        this.formSearch.get('destination')!.value,
      )
      searchModel.servico = this.toNullable(this.formSearch.get('service')!.value)
      searchModel.tipoVeiculoId = this.toNullableNumber(
        this.formSearch.get('vehicleType')!.value,
      )
      searchModel.tipoMotoristaId = this.toNullableNumber(
        this.formSearch.get('driverType')!.value,
      )
      searchModel.dataInicio = this.formSearch.get('dateStart')!.value
        ? moment(this.formSearch.get('dateStart')!.value).format('DD/MM/YYYY')
        : null
      searchModel.dataFinal = this.formSearch.get('dateEnd')!.value
        ? moment(this.formSearch.get('dateEnd')!.value).format('DD/MM/YYYY')
        : null
      searchModel.statusOsId = this.toNullableNumber(
        this.formSearch.get('statusOsId')!.value,
      )
      searchModel.consultorOperacionalId = this.toNullableNumber(
        this.employeeConsultantSelected?.id,
      )
      searchModel.fornecedorAtribuidoPor = this.toNullableNumber(
        this.formSearch.get('fornecedorAtribuidoPor')!.value,
      )
      this.responseSearch.emit({ search: search, model: searchModel })
    } else if (!search) {
      this.formSearch.reset({
        tgCode: '',
        osCode: '',
        client: '',
        origin: '',
        destination: '',
        service: '',
        vehicleType: '',
        driverType: '',
        dateStart: '',
        dateEnd: '',
        statusOsId: '',
        consultant: '',
        fornecedorAtribuidoPor: '',
      })
      this.employeeConsultantSelected = {}
      this.clientSelected = {}

      this.responseSearch.emit({ search: search, model: {} })
    }
  }

  private toNullable(value: string): string | null {
    return value && value.trim().length > 0 ? value : null
  }

  private toNullableNumber(value: any): number | null {
    return value !== null && value !== undefined && value !== ''
      ? value
      : null
  }

  checkSearch() {
    const fields = [
      'tgCode',
      'osCode',
      'origin',
      'destination',
      'service',
    ]
    if (fields.some((f) => this.formSearch.get(f)!.value.trim().length > 0)) {
      return true
    }
    if (
      this.formSearch.get('dateStart')!.value ||
      this.formSearch.get('dateEnd')!.value
    ) {
      return true
    }
    if (this.formSearch.get('statusOsId')!.value) {
      return true
    }
    if (this.formSearch.get('vehicleType')!.value) {
      return true
    }
    if (this.formSearch.get('driverType')!.value) {
      return true
    }
    if (this.employeeConsultantSelected?.id) {
      return true
    }
    if (this.clientSelected?.id) {
      return true
    }
    if (this.formSearch.get('fornecedorAtribuidoPor')!.value) {
      return true
    }
    return false
  }

  openDatepicker(type: 'dateStart' | 'dateEnd') {
    if (type == 'dateStart') {
      this.datepickerStart()?.open()
    } else if (type == 'dateEnd') {
      this.datepickerEnd()?.open()
    }
  }
}
